import { Modal } from "antd";
import { TriangleAlert } from "lucide-react";
import React from "react";

function NoCreditModal({ creditModalFlag, setCreditModalFlag, noClosable }) {
  return (
    <Modal
      open={creditModalFlag}
      centered
      onCancel={() => {
        if (!noClosable) {
          setCreditModalFlag(false);
        }
      }}
      footer={null}
      title="Insufficient Credits / Unauthorized"
      width={420}
      closable={noClosable ? false : true}
    >
      <div className="mt-5">
        <div className="flex justify-center items-center">
          <TriangleAlert color="red" size={50} />
        </div>
        <div className="text-center mt-3 text-gray-600 font-medium">
          Your credits have expired or your Organization has not allowed you to
          create more guides. Please recharge credits or reach out to your
          Organization for more information.
        </div>
      </div>
    </Modal>
  );
}

export default NoCreditModal;
